import React,{Component} from 'react';
import {
  Row,
  Col,
  Input,
  Label,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormText
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import HiddenInput from '../../../shared/components/HiddenInput';
import TextInput from '../../../shared/components/TextInput';
import Button from '../../../shared/components/Button';

import AdjoyTermsAndConditions from './AdjoyTermsAndConditions';

import { finalizeUser, checkUniquenessOfAgencyName } from '../utils';
import { alertSalesTeam } from '../../../shared/utils';
import { UPDATE_LATENCY, ACTIVE_PROFILE } from '../../../config';

class OnboardingSignup extends Component {
  constructor(){
    super();

    this.state = {
      step:'profile',
      agencyExists:false,
      isSaving:false,
      isViewingTermsAndConditions:false,
      agreesToTermsAndConditions:false,
      validationMessages:{},
      user:null,
      account:null,
      error:null
    };
  }

  componentDidMount(){}

  handleUserFormSubmit(data){
    const user = data.user,
      validationMessages = {};

    if(!user.firstName || user.firstName.length === 0){
      validationMessages['userFirstName'] = 'First name is required';
    }

    if(!user.lastName || user.lastName.length === 0){
      validationMessages['userLastName'] = 'Last name is required';
    }

    if(!user.password){
      validationMessages['userPassword'] = 'Password is required';
    }

    if(user.password && user.password.length < 8){
      validationMessages['userPassword'] = 'Password must be at least 8 characters in length';
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
    } else {
      this.setState({user:user,step:'company'});
    }
  }

  handleAccountFormSubmit(data){
    const account = data.account || {},
      user = Object.assign({role:''},(data.user || {}),this.state.user),
      { agencyExists } = this.state,
      validationMessages = {},
      { requestAuthTokenWithCredentials, history, isInvite } = this.props;

    if(agencyExists) return;

    if((!account.name || account.name.length === 0) && !isInvite){
      validationMessages['accountName'] = 'Your company name is required to create an account';
    }

    if(!this.state.agreesToTermsAndConditions){
      validationMessages['agreesToTermsAndConditions'] = 'You must agree to Dabbl Terms & Conditions to create an account';
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
    } else {
      
      this.setState({isSaving:true});

      if(isInvite){
        //TODO: Pull the created user and read their permissions
        return finalizeUser(user.id, user.password, user.firstName,user.lastName, user.role, user.token)
          .then((res) => new Promise((resolve) => window.setTimeout(() => resolve(res),UPDATE_LATENCY)))
          .then(() => requestAuthTokenWithCredentials(user.email,user.password))
          .then(() => this.alertSalesTeamIfNeeded(user,account))
          .then(() => this.setState({isSaving:false}))
          .then(() => history.push('/invite/demo'))
          .catch((err) => this.setState({error:err}));

      } else {
        return finalizeUser(user.id, user.password, user.firstName,user.lastName, user.role, user.token, account.name, account.URL)
          .then((res) => new Promise((resolve) => window.setTimeout(() => resolve(res),UPDATE_LATENCY)))
          .then(() => requestAuthTokenWithCredentials(user.email,user.password))
          .then(() => this.alertSalesTeamIfNeeded(user,account))
          .then(() => this.setState({isSaving:false}))
          .then(() => history.push('/welcome/demo'))
          .catch((err) => this.setState({error:err}));
      } 
    }
  }

  handleCheckIfAccountExists(name){
    checkUniquenessOfAgencyName(name.trim())
      .then((res) => this.setState({agencyExists:!!res.id}))
  }

  handleViewTermsClick(e){
    e.stopPropagation();
    e.preventDefault();
    this.setState({isViewingTermsAndConditions:true});
  }

  alertSalesTeamIfNeeded(user,account){
    if(ACTIVE_PROFILE === 'prod'){
      return this.props.loadUser(user.id)
        .then((res) => alertSalesTeam(`${user.firstName} ${user.lastName}`,user.email,res.instance.isOwner ? 'Admin' : 'Creator',account.name));
    } else {
      return Promise.resolve();
    }
  }

  render(){
    const {
      step,
      agreesToTermsAndConditions,
      isViewingTermsAndConditions,
      validationMessages,
      agencyExists
    } = this.state;

    const {
      queryStringParams,
      isInvite
    } = this.props;

    return (
      <div className='OnboardingPortal'>
        <Modal
          size='lg'
          isOpen={isViewingTermsAndConditions}
          toggle={() => this.setState({isViewingTermsAndConditions:!isViewingTermsAndConditions})}
        >
          <ModalHeader>
            Dabbl Terms and Conditions v3 (effective 9/14/18)
          </ModalHeader>
          <ModalBody>
            <AdjoyTermsAndConditions />
          </ModalBody>
          <ModalFooter>
            <Button 
              onClick={() => this.setState({
                isViewingTermsAndConditions:false,
                agreesToTermsAndConditions:true
              })}
            >
              I agree
            </Button>
          </ModalFooter>
        </Modal>
        <Row>
          <Col xs={12} md={{size:6,offset:3}}>
            <div id='chat-widget'></div>
            <br />
            <br />
            <br />
            <br />
            <h2>
              {step === 'profile' ? 'Create your profile' : 'Add your company'}
              &nbsp;
              <span className='OnboardingStep'>{step === 'profile' ? 1 : 2} of 2</span>
            </h2>
            <br />
            <br />
            <div style={{display: step === 'profile' ? 'block' : 'none'}}>
              <Form onSubmit={(data) => this.handleUserFormSubmit(data)}>
                <HiddenInput name='user[id]' value={queryStringParams.userId} />
                <HiddenInput name='user[token]' value={queryStringParams.token} />
                <TextInput 
                  name='user[email]' 
                  placeholder='Email' 
                  defaultValue={queryStringParams.email}
                  readOnly={!!queryStringParams.email}
                />
                <Row>
                  <Col xs='6'>
                   <TextInput
                    name='user[firstName]'
                    placeholder='First name'
                    warning={validationMessages['userFirstName']}
                  />
                  </Col>
                  <Col xs='6'>
                    <TextInput
                      name='user[lastName]'
                      placeholder='Last name'
                      warning={validationMessages['userLastName']}
                    />
                  </Col>
                </Row>
                <TextInput
                  name='user[password]'
                  placeholder='Create a password'
                  warning={validationMessages['userPassword']}
                  hidden
                />
                <Button isSubmit>
                  Next: Your company
                </Button>
              </Form>
            </div>
            <div style={{display: step === 'company' ? 'block' : 'none'}}>
              <Form onSubmit={(data) => this.handleAccountFormSubmit(data)}>
                <FormGroup>
                  <TextInput
                    name='account[name]'
                    placeholder={'Your company\'s name'}
                    warning={agencyExists ? 'This name is already taken please choose another one' : validationMessages['accountName']}
                    maxLength={80}
                    debounce={500}
                    onChange={(name) => this.handleCheckIfAccountExists(name)}
                    defaultValue={isInvite ? queryStringParams.agencyName : ''}
                    readOnly={isInvite}
                  />
                </FormGroup>
                <FormGroup>
                  <TextInput
                    name='account[URL]'
                    placeholder='Company URL'
                    defaultValue={isInvite ? queryStringParams.companyWebsiteURL : ''}
                    readOnly={isInvite}
                  />
                </FormGroup>
                <FormGroup>
                  <TextInput
                    name='user[role]'
                    placeholder='What is your role?'
                  />
                </FormGroup>
                <FormGroup>
                  <Label check>
                    <Input
                      type='checkbox'
                      name='agreesToTermsAndConditions'
                      checked={agreesToTermsAndConditions}
                      onClick={() => this.setState({agreesToTermsAndConditions:!agreesToTermsAndConditions})}
                    />
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;I agree to the&nbsp;</span>
                    <span
                      className='FakeLink'
                      onClick={(e) => this.handleViewTermsClick(e)}
                    >
                      Dabbl Terms and Conditions
                    </span>
                  </Label>
                  {validationMessages['agreesToTermsAndConditions'] && (
                    <FormText className='DangerFeedback'>
                      {validationMessages['agreesToTermsAndConditions']}
                    </FormText>
                  )}
                </FormGroup>
                <Button isSubmit>
                  Finish account set up
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default OnboardingSignup;



// WEBPACK FOOTER //
// ./src/routes/OnboardingSignup/components/OnboardingSignup.js